<div class="search-dialog">
  <div class="search-dialog__header">
    <h2 class="search-dialog__title">Search chargepoints</h2>
    <button mat-icon-button type="button" aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form class="search-form" [formGroup]="data.searchFormGroup">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Chargepoint type</mat-label>
      <mat-select formControlName="type">
        <mat-option value="all">All</mat-option>
        <mat-option value="OCPP">OCPP</mat-option>
        <mat-option value="OKECHARGE">OkeCharge</mat-option>
        <mat-option value="IVY">Ivy</mat-option>
        <mat-option value="NETATMO">Netatmo</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Search by ID</mat-label>
      <input matInput type="text" placeholder="some/id ..." formControlName="id">
      @if (data.searchFormGroup.get('id')?.value) {
        <button matSuffix mat-icon-button type="button" aria-label="Clear" (click)="data.searchFormGroup.controls['id'].setValue('')">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Advanced filter</mat-label>
      <mat-select formControlName="advancedFilter">
        <mat-option *ngFor="let filter of data.advancedFilterOptions" [value]="filter.id">
          {{ filter.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="search-form__order">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Order by</mat-label>
        <mat-select formControlName="orderBy">
          <mat-option value="id">Identifier</mat-option>
          <mat-option value="type">Type</mat-option>
          <mat-option value="status">Status</mat-option>
          <mat-option value="lastHeartbeat">Last heartbeat</mat-option>
        </mat-select>
      </mat-form-field>

      <button
        mat-icon-button
        type="button"
        aria-label="Toggle sort direction"
        (click)="data.searchFormGroup.controls['reverse'].setValue(!data.searchFormGroup.controls['reverse'].value)"
      >
        <mat-icon>{{ data.searchFormGroup.controls['reverse'].value ? 'arrow_downward' : 'arrow_upward' }}</mat-icon>
      </button>
    </div>
  </form>
</div>
